import styled from "styled-components";

export const SumWrapper = styled.div`
  padding-bottom: 14px;
`;
